module.exports = __webpack_public_path__ + "img/salmon_crudo_garnished_straight.c6cc0d3b.jpg";